import * as React from 'react';
import '../App.css';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../GlobalState';
import { ResponsiveBar } from '@nivo/bar';

type GraphStatus = {
  title: string;
  targetValue: number;
  realValue: number;
};

const GoalAchievementRateBarGraph: React.FC<GraphStatus> = graphStatus => {
  const [mainColor] = useRecoilState(mainBlueColor);

  const data = [
    {
      state: graphStatus.title,
      TargetValue: graphStatus.targetValue,
      RealValue: graphStatus.realValue
    }
  ];
  return (
    <div
      key={graphStatus.realValue}
      style={{ height: 300 }}
      className={'responsive-container-bottom-goal-achivement-graph'}
    >
      <ResponsiveBar
        key={graphStatus.realValue}
        groupMode='grouped'
        data={data}
        keys={['TargetValue', 'RealValue']}
        indexBy='state'
        margin={{
          top: 20,
          right: 0,
          bottom: 30,
          left:
            Math.max(graphStatus.targetValue, graphStatus.realValue).toString()
              .length <= 3
              ? 30
              : Math.max(
                  graphStatus.targetValue,
                  graphStatus.realValue
                ).toString().length * 9
        }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={['#CCCCCC', mainColor]}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        label={''}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        animate={true}
        motionConfig={{
          mass: 1,
          tension: 90,
          friction: 15,
          clamp: false,
          precision: 0.01,
          velocity: 0
        }}
        axisBottom={{
          tickSize:
            graphStatus.targetValue === 0 && graphStatus.realValue === 0 ? 0 : 5
        }}
        tooltip={({ value, color, indexValue }) => {
          return (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                backgroundColor: 'white',
                padding: '0.25rem'
              }}
            >
              {' '}
              <div className='square' style={{ backgroundColor: color }} />
              <div>
                {indexValue}
                {' : '}
                <span style={{ fontWeight: 'bold' }}>
                  {value.toLocaleString()}
                </span>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};
export default GoalAchievementRateBarGraph;
